import React, { useState } from 'react';
import { EmptyState, Spinner } from '@spark';
import { useAuth } from '@/features/auth/AuthContext';
import TaskPageTabEmpty from '@/features/tasks/components/TaskPageTabEmpty';
import { useInferenceData } from './Inference/useInferenceData';
import InferenceHeader from './Inference/InferenceHeader';
import PerformanceInfoBar from './Inference/PerformanceInfoBar';
import LivePerformanceSection from './Inference/LivePerformanceSection';
import InputSizeCard from './Inference/InputSizeCard';
import PredictionsCard from './Inference/PredictionsCard';
import RecentPayloadsSection from './Inference/RecentPayloadsSection';

import './Inference/inference-tab.css';

const TaskInferenceTab = ({ activeUsecase }) => {
    const [timeRange, setTimeRange] = useState('last-hour');
    const { workspace } = useAuth() ?? {};

    const { data, loading, error, lastUpdated, refresh } = useInferenceData({
        workspaceId: workspace?.id,
        usecaseId: activeUsecase?._id,
        timeRange,
    });

    if (!activeUsecase?._id) return null;

    if (loading && !data) {
        return (
            <div className="task-page-tab-loading" role="status" aria-label="Loading inference data">
                <Spinner size="large" />
            </div>
        );
    }

    if (error) {
        return (
            <TaskPageTabEmpty>
                <EmptyState
                    title="Failed to load inference data"
                    subtitle={error}
                    showSubtitle
                    showMainButton={false}
                />
            </TaskPageTabEmpty>
        );
    }

    return (
        <div className="inference-tab">
            <InferenceHeader onRefresh={refresh} />

            <PerformanceInfoBar performanceInfo={data?.performanceInfo} />

            <LivePerformanceSection
                latency={data?.latency}
                throughput={data?.throughput}
                requests={data?.requests}
                lastUpdated={lastUpdated}
                timeRange={timeRange}
                onTimeRangeChange={setTimeRange}
            />

            <div className="metrics-row">
                <InputSizeCard inputSize={data?.inputSize} />
                <PredictionsCard predictions={data?.predictions} />
            </div>

            <RecentPayloadsSection payloads={data?.recentPayloads} />
        </div>
    );
};

export default TaskInferenceTab;
